module.exports = __webpack_public_path__ + "static/media/logo.17c4c85a.svg";